// Set an observer to trigger animations from animate.css
// NOTE: Only tested with entrance animations
// 
// The animated element  is expected to have:
//  * Class "animated"
//  * Data field called data-animation-type with animation type
//    |_ Fallback animation it's  fadeInLeft
/* 
  <div class="animated" data-animation-type="fadeInLeft">
    <p>Cool text</p>
  </div> 
*/

// REQUIRES: 
// * animate.css stylesheet
// * set-class-if-visible.js
//   |_ util-set-attribute.js
const setAnimations = function () {
  const animationClass = ".animated";
  const animateType = "fadeInLeft";
  if (!document.querySelector(animationClass)) return;

  const elmnts = Array.from(document.querySelectorAll(animationClass));
  elmnts.map(e => {
    const animation = e.dataset.animationType && e.dataset.animationType != "" ? e.dataset.animationType : animateType;
    setClassIfVisible(e, animation)
  });
}

document.addEventListener('DOMContentLoaded', (e) => { setAnimations() });